/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import parse from 'html-react-parser';
import Select from 'react-select';

// local imports
import Logo from '../../assets/UW_Horizontal_Logo_Full.png'

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import OrganisationService from '../../services/OrganisationService';
import GeneralService from '../../services/GeneralService';

const OrganisationNavbar = (props) => {

    // contexts
    const { theme, colors, fontFamily } = useContext(ThemeContext);
    const { user, setUser, setIsAuthenticated, maintenance, timeZones, selectedTimeZone, setSelectedTimeZone, userApprovalStatus, setUserApprovalStatus } = useContext(AuthContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenMenuDropdown, setIsOpenMenuDropdown] = useState(false);
    const [isOpenProfileDropdown, setIsOpenProfileDropdown] = useState(false);
    const [notifications, setNotifications] = useState({
        AvailableTimings: [],
        OrganisationProfile: [],
        OrganisationSession: [],
        MyClient: [],
        MyPricing: [],
        OrganisationPayment: [],
        System: []
    });
    const [generalAlertModal, setGeneralAlertModal] = useState({ visible: false, detail: { id: "", title: "", description: "" } });
    const [policyNConditionStatusAlertModal, setPolicyNConditionStatusAlertModal] = useState({ visible: false, detail: { id: "", title: "", description: "" } });
    const [agreeBox, setAgreeBox] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [selectedUserRoleValue, setSelectedUserRoleValue] = useState({});

    // useEffects
    useEffect(() => {
        let tempUserRoles = [];
        if (user.roles.includes('client')) {
            tempUserRoles.push({ label: 'Client', value: 'client' })
            if (user.selectedRole === 'client') {
                setSelectedUserRoleValue({ label: 'Client', value: 'client' });
            }
        } else {
            tempUserRoles.push({ label: 'Client', value: 'addClient' })
        }
        if (user.roles.includes('provider')) {
            tempUserRoles.push({ label: 'Counsellor', value: 'provider' })
            if (user.selectedRole === 'provider') {
                setSelectedUserRoleValue({ label: 'Counsellor', value: 'provider' });
            }
        } else {
            tempUserRoles.push({ label: 'Counsellor', value: 'addOrganisation' })
        }
        if (user.roles.includes('organisation_admin')) {
            setUser({ ...user, selectedRole: 'organisation_admin' })
            tempUserRoles.push({ label: 'Organsation', value: 'organsation_admin' })
            setSelectedUserRoleValue({ label: 'Organsation', value: 'organisation_admin' });
        } else {
            tempUserRoles.push({ label: 'Organsation', value: 'addOrgansation' })
        }
        setUserRoles(tempUserRoles);
        OrganisationService.getApprovalStatus().then(data => {
            // console.log('userApprovalStatus', data);
            setUserApprovalStatus(data.isApproved);
        })
        OrganisationService.getOrganisationProfileImageAndEmail()
            .then(data => {
                try {
                    setUser({ ...user, profileImage: data.profileImage });
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Organisation OrganisationNavbar useEffect', 'Error in try catch block', err.stack);
                }
            })
    }, []);

    // utility functions
    const toggleMenuDropdown = () => setIsOpenMenuDropdown(!isOpenMenuDropdown);
    const toggleProfileDropdown = () => setIsOpenProfileDropdown(!isOpenProfileDropdown);

    // handle functions
    const handleChangeSelectedUserRole = (e) => {
        if (e.value === 'addClient') {
            props.history.push('/client/landingscreen');
        } else if (e.value === 'addProvider') {
            props.history.push('/counsellor/landingscreen');
        } else if (e.value === 'addOrgansation') {
            props.history.push('/organisation/landingscreen');
        } else {
            setSelectedUserRoleValue(e);
            setUser({ ...user, selectedRole: e.value })
            if (e.value === 'client') {
                props.history.push('/client/dashboard');
            } else if (e.value === 'provider') {
                props.history.push('/counsellor/sessions');
            } else if (e.value === 'organsation_admin') {
                props.history.push('/organisation/dashboard');
            }
        }
    }

    const handleLogout = () => {
        try {
            AuthService.logout().then(data => {
                if (data.success) {
                    setUser(data.user);
                    setIsAuthenticated(false);
                    // props.history.push('/');
                } else {

                }
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Organisation OrganisationNavbar handleLogout', 'Error in try catch block', err.stack);
        }
    }

    const handlePolicyNConditionStatusSubmit = () => {
        if (!agreeBox) return;
        setIsLoading(true);
        AuthService.markNotificationAsRead("System", policyNConditionStatusAlertModal.detail.id).then((data) => {
            // const id = policyNConditionStatusAlertModal.detail.id;
            // for (let i = (user.notifications.System.length - 1); i >= 0; i--) {
            //     if (user.notifications.System[i]._id === id) {
            //         let tempNotification = { ...user.notifications };
            //         tempNotification.System[i].readStatus = true;
            //         setUser({ ...user, notifications: tempNotification });
            //         break;
            //     }
            // }
            setPolicyNConditionStatusAlertModal({ visible: false, detail: { id: "", title: "", description: "" } });
            setIsLoading(false);
        })
    }

    return (
        <div>
            {maintenance.status ? <div className="alert alert-primary marquee" style={{ margin: "0 -15px" }}><div>Umang Wellness is going to conduct maintenace to improve your experience. It will go under maintenance on {moment(maintenance.startAt).format("DD-MM-YYYY [at] hh:mm A")} for {maintenance.duration} minutes. During these time you won't be able to use Umang Wellness.</div></div> : null}
            <Navbar id="provider-navbar" color="white" light expand="md" style={{ fontFamily: fontFamily.primary }}>
                <NavbarBrand className="p-0" href="/">
                    <img id="brand-logo" style={{ maxWidth: "160px", height: "auto", border: "none", margin: "0" }} src={Logo} alt="Umang Logo" />
                </NavbarBrand>
                <NavbarToggler onClick={toggleMenuDropdown} />
                <Collapse isOpen={isOpenMenuDropdown} navbar>
                    <Nav className="ml-auto" navbar>
                        <NavItem className="my-auto mr-2" style={{ width: "10rem" }}>
                            <Select
                                value={selectedTimeZone}
                                onChange={(e) => setSelectedTimeZone(Object.assign({ isDST: moment().isDST() }, e))}
                                options={timeZones}
                            />
                        </NavItem>
                        <NavItem className="my-auto mr-2" style={{ width: "10rem" }}>
                            <Select
                                value={selectedUserRoleValue}
                                onChange={(e) => handleChangeSelectedUserRole(e)}
                                options={userRoles}
                            />
                        </NavItem>
                        <NavItem>
                            <Dropdown id="profile-menu" className="ml-auto" isOpen={isOpenProfileDropdown} toggle={toggleProfileDropdown}>
                                <DropdownToggle style={{ border: 0, background: 'transparent', padding: 0 }} id="profileDropdown">
                                    <div className="text-center" style={{ width: "45px", height: "45px" }}>
                                        <img className="w-100 h-100" src={user.profileImage} alt="Profile picture" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                                    </div>
                                    {(notifications.OrganisationProfile.length + notifications.OrganisationSession.length + notifications.AvailableTimings.length + notifications.MyPricing.length + notifications.MyClient.length + notifications.OrganisationPayment.length) > 0 ? <span className="notificationBadge">{notifications.OrganisationProfile.length + notifications.OrganisationSession.length + notifications.AvailableTimings.length + notifications.MyPricing.length + notifications.MyClient.length + notifications.OrganisationPayment.length}</span> : null}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem id="user-email" header>
                                        {user.email}
                                    </DropdownItem>
                                    <DropdownItem id="user-name" className="mt-0 pt-0" header>
                                        {user.username}
                                    </DropdownItem>
                                    <DropdownItem id="user-name" className="mt-0 pt-0" header>
                                        {`Last login: ${user.lastLoginAt ? user.lastLoginAt.old ? moment(user.lastLoginAt.old).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY HH:mm") : moment(user.lastLoginAt.new).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY HH:mm") : ""}`}
                                    </DropdownItem>
                                    <Link to="/organisation/dashboard">
                                        <DropdownItem>Dashboard</DropdownItem>
                                    </Link>
                                    <Link id="profile-link" to="/organisation/profile">
                                        <DropdownItem>My Profile</DropdownItem>
                                    </Link>
                                    <Link to="/organisation/organisationProfile">
                                        <DropdownItem>Organisation Profile</DropdownItem>
                                    </Link>
                                    <Link to="/organisation/myplan">
                                        <DropdownItem>My Plan</DropdownItem>
                                    </Link>
                                    <Link to="/organisation/settings">
                                        <DropdownItem>Account Settings</DropdownItem>
                                    </Link>
                                    <Link to="/contactus">
                                        <DropdownItem>Contact Us</DropdownItem>
                                    </Link>
                                    <DropdownItem id="guided-tour-link" onClick={props.showTutorial}>Guided Tour</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem id="logout" onClick={handleLogout}>Logout</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
            <Modal size="sm" isOpen={generalAlertModal.visible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setGeneralAlertModal({ visible: false, detail: { title: "", description: "" } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>{generalAlertModal.detail.title}</span></ModalHeader>
                <ModalBody>{generalAlertModal.detail.description}</ModalBody>
                <ModalFooter><Button onClick={() => setGeneralAlertModal({ visible: false, detail: { title: "", description: "" } })}>Ok</Button></ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={policyNConditionStatusAlertModal.visible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setPolicyNConditionStatusAlertModal({ visible: false, detail: { title: "", description: "" } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>{policyNConditionStatusAlertModal.detail.title}</span></ModalHeader>
                <ModalBody>
                    {parse(policyNConditionStatusAlertModal.detail.description)}
                    <div className="form-check mt-2">
                        <input className="form-check-input" type="checkbox" style={{ width: "1rem", height: "1rem" }} id="agree" checked={agreeBox} onChange={(e) => setAgreeBox(e.target.checked)} />
                        <label className="form-check-label ml-2" htmlFor="cb4">I have read and agree to updated Privacy Policy.</label>
                    </div>
                </ModalBody>
                <ModalFooter style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                    <Button type="button" style={theme.formSubmit} disabled={!agreeBox} onClick={() => handlePolicyNConditionStatusSubmit()}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default OrganisationNavbar;